import React from 'react';
import '../Colors.css';

const ThumbUp = ({className, heightStyle}) => {
  return (
    <svg height={heightStyle} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path className='HslGreen' d="M567.362 47.934c42.786 71.401-5.726 160.818-42.075 238.812-31.245 67.059-26.48 143.142 57.291 133.395 100.937-11.748 141.675-19.822 227.591-25.692 86.765-5.925 114.151 29.709 114.151 62.717 0 53.299-17.799 57.309-17.799 77.756 0 20.443 66.55 7.117 66.55 74.172 0 67.153-51.995 64.96-51.995 83.68 0 18.771 50.611 27.177 50.611 80.862s-68.215 60.798-68.215 82.961c0 22.163 22.040 27.939 22.040 61.185 0 33.195-69.216 106.226-313.453 106.226-416.207 0-366.835-99.824-561.13-99.824v-368.818c101.132 0 95.648-89.608 165.435-158.047 70.408-69.017 205.075-225.294 231.551-348.473 17.698-82.441 93.018-44.994 119.447-0.91z"/>
    </svg>
  );
};

export default ThumbUp;